// extracted by mini-css-extract-plugin
module.exports = {"bubble-stack":"ChatBubbles_bubble-stack__MSZzg","bubble":"ChatBubbles_bubble__3HhRa","focused":"ChatBubbles_focused__nn6Uk"};